/* The entry point: choose a type of school.
   OWNED BY ITEM 4 OF docs/plan/00-prestavba-2026-08.md.

   Four tiles and nothing else above the fold. This is the page that replaced a
   hub of nine cards, because teachers were observed starting here — with what
   they teach — and not with what the material is about. */

import { Link } from "react-router-dom";
import { covers } from "../../lib/covers";
import { useI18n } from "../../lib/i18n";
import { usePortal } from "../../lib/portal";
import { useIndex, inStrand } from "../../lib/hooks";
import { Billboard, Grid, Tile } from "./Tile";
import { plural } from "./plural";

export function StrandChooser() {
  const { ui, href } = useI18n();
  const { taxonomy } = usePortal();
  const { data: index } = useIndex();
  if (!taxonomy) return null;

  return (
    <div className="catalog">
      <Billboard eyebrow={ui("home.eyebrow")} title={ui("home.title")} lead={ui("home.lead")} />
      <Grid>
        {taxonomy.strandIds.map((id) => {
          const s = taxonomy.strands[id];
          if (!s) return null;
          const count = index ? inStrand(index, id).length : 0;
          return (
            <Tile key={id} wide to={href(`/s/${id}`)} art={covers.strand(id)}
                  title={s.name} sub={s.who}
                  foot={count ? plural(count, ui) : null} />
          );
        })}
      </Grid>
      <p className="cat-more">
        {ui("home.general")}{" "}
        <Link to={href("/prehled")}>{ui("home.overviewLink")}</Link>
      </p>
    </div>
  );
}
